<template>
   <div class="text-input">
      <div class="label-wrapper">
        <label><b>{{ label }}</b></label>
        <label :style="{color: headerColor}">{{ header }}</label>
      </div>
      
      <div class="input-group">
        <input type="text" class="form-control"
               :placeholder="placeholder"
               :value="value"
               @input="$emit('input',$event.target.value)"
               :aria-label="label">
      </div>
   </div>
</template>

<script>
export default {
  name: "TextInputWithRightHeader",
  props: ['label', 'placeholder', 'value', 'header', 'headerColor'],
}
</script>

<style lang="scss" scoped>
  .label-wrapper {
    display: flex;
    justify-content: space-between;
    align-content: center;
    
  }
</style>
